import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import ClientReportsTab from "../../../../components/Events/Event/ClientReports";
import {
  getAdminClientReport,
  getAdminClientReports,
} from "../../../../network/apis/adminPortalClientReports";
import messages from "../../../../assets/locale/messages";
import { ROUTE_PATHS } from "../../../../utils/RoutesPaths";
import { isSuperAdmin } from "../../../../utils/Permissions";

const adminClientReportsApi = {
  getList: getAdminClientReports,
  getFile: getAdminClientReport,
};

/** Admin Portal Client Reports — read-only (PROLINE-3632 / PROLINE-3640):
 * list + per-row download only. No upload, delete or preview.
 * Download-all is available to Super Admin (PROLINE-3695). */
const AdminEventClientReportsTab = ({ event }) => {
  const history = useHistory();
  const lang = useSelector((state) => state.locale.lang);
  const { clientReports } = messages[lang];

  const handleForbidden = useCallback(() => {
    history.replace(ROUTE_PATHS.events);
  }, [history]);

  return (
    <ClientReportsTab
      event={event}
      api={adminClientReportsApi}
      canUpload={false}
      canDelete={false}
      canDownloadAll={isSuperAdmin()}
      canPreview={false}
      downloadErrorMessage={clientReports.downloadRetryError}
      onForbidden={handleForbidden}
    />
  );
};

AdminEventClientReportsTab.propTypes = {
  event: PropTypes.object,
};

AdminEventClientReportsTab.defaultProps = {
  event: null,
};

export default AdminEventClientReportsTab;
